enum UnitType {
  BOOK_TASK = "BOOK_TASK",
  RESOURCE_BOOK = "RESOURCE_BOOK",
  FINAL_TEST = "FINAL_TEST",
  EXTRA_SUPPORT = "EXTRA_SUPPORT",
  WRITTEN_TEST = "WRITTEN_TEST",
}

export default UnitType;